// For flash message
export default {
    namespaced: true,
    state: {
        sidebarShow: false,
        sidebarComponent: null,
        sidebarParams: {},
    },
    mutations: {
        sidebar: function(state, isShow) {
            state.sidebarShow = isShow;
        },
        sidebarComponent: function(state, component) {
            state.sidebarComponent = component;
        },
        sidebarParams: function(state, params) {
            state.sidebarParams = params;
        },
    },
    actions: {
        sidebar: function(context, isShow) {
            context.commit('sidebar', isShow);
        },
        sidebarComponent: function(context, component) {
            context.commit('sidebarComponent', component);
        },
        sidebarParams: function(context, params) {
            context.commit('sidebarParams', params);
        },
    }
};